export default "__VITE_ASSET__5507a6fd__"